"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketSubmissionPrizeDTO = void 0;
var TicketSubmissionPrizeDTO = /** @class */ (function () {
    function TicketSubmissionPrizeDTO(data) {
        this.id = data.id;
        this.externalId = data.externalId;
        this.prizeType = data.prizeType;
        this.amount = data.amount;
        this.status = data.status;
        this.baseAmount = data.baseAmount;
        this.bonusAmount = data.bonusAmount;
        this.extraData = data.extraData;
        this.token = data.token;
        this.draw = data.draw;
        this.preassigned = data.preassigned;
        this.hasWinningTicket = data.hasWinningTicket;
        this.prizeLevelBreakdown = data.prizeLevelBreakdown;
    }
    TicketSubmissionPrizeDTO.JsonToTicketSubmissionPrizeDTO = function (data) {
        return new TicketSubmissionPrizeDTO(data);
    };
    return TicketSubmissionPrizeDTO;
}());
exports.TicketSubmissionPrizeDTO = TicketSubmissionPrizeDTO;
//# sourceMappingURL=TicketSubmissionPrizeDTO.js.map